import React, { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useAxiosInstance } from "../../../services/Interceptor";
import { CreateOffer } from "../../../services/AthleteService";
import { toast } from "react-toastify";
import { divisions } from "../../../utils/PositionStateData";

export default function AddOfferModal({ open, onClose, athleteId, onSaved }) {
  const apiInstance = useAxiosInstance();

  const [schoolName, setSchoolName] = useState("");
  const [division, setDivision] = useState("Division 1 (FBS)");
  const [offerYear, setOfferYear] = useState("");

  const save = async () => {
    if (!schoolName.trim()) {
      toast.warning("School is required", { position: "top-right" });
      return;
    }
    if (!offerYear || String(offerYear).length !== 4) {
      toast.warning("Enter a valid 4-digit year", { position: "top-right" });
      return;
    }

    try {
      const payload = {
        userId: athleteId,
        schoolName: schoolName.trim(),
        division,
        offerYear: Number(offerYear),
      };

      await CreateOffer(apiInstance, payload);
      toast.success("Offer added!", { position: "top-right" });
      await onSaved?.();
      setSchoolName("");
      setDivision("Division 1 (FBS)");
      setOfferYear("");
    } catch (e) {
      toast.error("Failed to add offer", { position: "top-right" });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[300]">
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="w-full max-w-lg bg-white rounded-lg shadow-xl">
          <div className="p-6">
            <DialogTitle className="text-lg font-bold mb-4">
              New Offer
            </DialogTitle>

            <div className="space-y-3">
              <div>
                <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">
                  School
                </label>
                <input
                  className="w-full border rounded p-2"
                  value={schoolName}
                  onChange={(e) => setSchoolName(e.target.value)}
                  placeholder="School..."
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">
                  Division
                </label>
                <select
                  className="w-full border rounded p-2"
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  {divisions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">
                  Year
                </label>
                <input
                  type="number"
                  className="w-full border rounded p-2"
                  value={offerYear}
                  onChange={(e) => setOfferYear(e.target.value)}
                  placeholder="2025"
                  min={1900}
                  max={2100}
                />
              </div>
            </div>
          </div>

          <div className="px-6 py-4 bg-gray-50 flex justify-end gap-3">
            <button className="px-4 py-2 border rounded" onClick={onClose}>
              Cancel
            </button>
            <button
              className="px-5 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              onClick={save}
            >
              Add
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
